import { Typography } from "@mui/material";
import { CustomRadio } from "../../widget/FearturesInputTypes/FeatureInputs";
import { CustomInfoPopover } from "./CustomInfoPopover";

interface CustomToggleButtonsProps {
  title?: string;
  handleToggleChangeEvent: (e: React.ChangeEvent<HTMLInputElement>) => void;
  values: Record<string, any>;
  buttonsInfo: { label: string; value: string; name: string }[];
  popOverContent?: string;
  vertical?: boolean;
}
const CustomToggleButtons: React.FC<CustomToggleButtonsProps> = ({
  title,
  handleToggleChangeEvent,
  values,
  buttonsInfo,
  popOverContent = null,
  vertical = false,
}) => {
  return (
    <>
      {title && (
        <Typography marginTop={popOverContent ? 0 : 1} color={"#606060"}>
          {title}
          {popOverContent && <CustomInfoPopover content={popOverContent} />}
        </Typography>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {/* First row: first two items */}
        <div style={{ display: "flex", gap: "8px" }}>
          {buttonsInfo.slice(0, 2).map((buttonInfo) => (
            <div
              style={{
                flex: "0 0 auto", // Keeps width based on content size
                textAlign: "left",
              }}
              key={buttonInfo.name + buttonInfo.label}
            >
              <CustomRadio
                label={buttonInfo.label}
                value={buttonInfo.value}
                name={buttonInfo.name}
                checked={values[buttonInfo.name] === buttonInfo.value}
                onChange={handleToggleChangeEvent}
                color="#909090"
              />
            </div>
          ))}
        </div>

        {/* Second row: remaining items */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {buttonsInfo.slice(2).map((buttonInfo) => (
            <div
              style={{
                flex: "0 0 auto", // Keeps width based on content size
                textAlign: "left",
              }}
              key={buttonInfo.name + buttonInfo.label}
            >
              <CustomRadio
                label={buttonInfo.label}
                value={buttonInfo.value}
                name={buttonInfo.name}
                checked={values[buttonInfo.name] === buttonInfo.value}
                onChange={handleToggleChangeEvent}
                color="#909090"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default CustomToggleButtons;
